// extracted by mini-css-extract-plugin
module.exports = {"block":"styles-module__block___RkJ8f","list":"styles-module__list___29jk6","button":"styles-module__button___cu7je","chevron":"styles-module__chevron___cziuU"};